import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import LogoutIcon from "@mui/icons-material/Logout";

export const LogoutMenu = ({children}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    return (
        <>
            <Button onClick={handleClick}>{children}</Button>
            <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
                <MenuItem>
                    <Button onClick={async ()=>{
                        localStorage.removeItem("tariff_id");
                        localStorage.removeItem("user_id");
                        localStorage.removeItem("vk_code_verifier");
                        localStorage.removeItem("vk_state");
                        document.location = document.location;
                        handleClose()
                    }} startIcon={<LogoutIcon/>}>Выйти</Button>
                </MenuItem>
            </Menu>
        </>
    );
}
